import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText, FDLabelText, FDStack } from '@facet-wealth/design';

const AdditionalDetailsList = ({ title, value }) => {
  return value?.length === 0 ? null : (
    <FDStack direction="column">
      <FDLabelText value={title} />
      {value.map((item) => {
        return (<FDBodyText value={item} />);
      })}
    </FDStack>
  );
};

AdditionalDetailsList.defaultProps = {
  title: '',
  value: [],
};

AdditionalDetailsList.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
};

export default AdditionalDetailsList;
